import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "daily-sync-work-schedule-selector" }
const _hoisted_2 = {
  key: 0,
  class: "daily-sync-work-schedule-selector__wrapper"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "daily-sync-add-working-hours__content" }, "⏰ Add working hours", -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppTimePicker = _resolveComponent("AppTimePicker")!
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_AppSelect = _resolveComponent("AppSelect")!
  const _component_AppDropdown = _resolveComponent("AppDropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.schedule && _ctx.schedule?.works)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_AppTimePicker, {
            minute: _ctx.schedule.startMinute,
            "onUpdate:minute": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.schedule.startMinute) = $event)),
            hour: _ctx.schedule.startHour,
            "onUpdate:hour": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.schedule.startHour) = $event)),
            "start-time": _ctx.startTime,
            "onUpdate:time": _ctx.updateTime
          }, null, 8, ["minute", "hour", "start-time", "onUpdate:time"]),
          _hoisted_3,
          _createVNode(_component_AppTimePicker, {
            minute: _ctx.schedule.endMinute,
            "onUpdate:minute": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.schedule.endMinute) = $event)),
            hour: _ctx.schedule.endHour,
            "onUpdate:hour": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.schedule.endHour) = $event)),
            "end-time": _ctx.endTime,
            "onUpdate:time": _ctx.updateTime
          }, null, 8, ["minute", "hour", "end-time", "onUpdate:time"]),
          _createVNode(_component_AppDropdown, {
            class: "daily-sync-work-schedule-selector__dropdown",
            type: "simple"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AppSelect, {
                modelValue: _ctx.schedule.location,
                "onUpdate:modelValue": [
                  _cache[5] || (_cache[5] = ($event: any) => ((_ctx.schedule.location) = $event)),
                  _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('update:modelValue', _ctx.schedule)))
                ],
                options: Object.values(_ctx.WorkLocation),
                min: 1,
                "close-on-select": ""
              }, {
                toggle: _withCtx(({ isFocusing, toggle }) => [
                  _createElementVNode("div", {
                    onClick: toggle,
                    onMousedown: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent","stop"])),
                    class: _normalizeClass(["app-dropdown__vue-select-trigger", { active: isFocusing }])
                  }, [
                    _createVNode(_component_AppIcon, { name: "arrow" })
                  ], 42, _hoisted_4)
                ]),
                label: _withCtx(({ selected }) => [
                  _createTextVNode(_toDisplayString(selected), 1)
                ]),
                "dropdown-item": _withCtx(({ option }) => [
                  _createElementVNode("p", null, _toDisplayString(option), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "options"])
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "daily-sync-add-working-hours",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.QuizService.edit(_ctx.QUIZ_STAGE_DEFINITION.AVAILABILITY, _ctx.QUIZ_AVAILABILITY_STAGE_DEFINITION.WORKING_HOURS)))
        }, _hoisted_6))
  ]))
}